export const CASE_REFERENCE_PATTERN = /^[\w\s-.]+$/;
export const CASE_REFERENCE_LENGTH_MIN = 3;
export const CASE_REFERENCE_LENGTH_MAX = 255;

export type CaseReferenceValidationError = "TOO_SHORT" | "TOO_LONG" | "INVALID_CHARACTERS";

export function validateCaseReference(caseReference: string): CaseReferenceValidationError | undefined {
  if (!CASE_REFERENCE_PATTERN.test(caseReference)) return "INVALID_CHARACTERS";
  if (caseReference.length < CASE_REFERENCE_LENGTH_MIN) return "TOO_SHORT";
  if (caseReference.length > CASE_REFERENCE_LENGTH_MAX) return "TOO_LONG";
  return undefined;
}

export function getCaseReferenceValidationMessage(error: string): string {
  switch (error) {
    case "TOO_SHORT":
      return `The name provided is shorter than the minimum ${CASE_REFERENCE_LENGTH_MIN} characters.`;
    case "TOO_LONG":
      return `The name provided is longer than the maximum ${CASE_REFERENCE_LENGTH_MAX} characters.`;
    case "INVALID_CHARACTERS":
      return "The name provided contains invalid characters. Only alphanumeric characters (A-Z, 0-9), periods (.), hyphens (-), underscores (_) and spaces are allowed.";
    default:
      return `Unknown error ${error}`;
  }
}
